import { render } from "./index.vue?vue&type=template&id=bc165f7c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/news-and-seminars-add/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc165f7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc165f7c', __exports__)) {
    api.reload('bc165f7c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=bc165f7c", () => {
    api.rerender('bc165f7c', render)
  })

}


export default __exports__